'use client';

import { JSX } from 'react';

import s from './styles.module.scss';
import { useModal } from '@/src/components/ui/ModalProvider';

export default function Hero(): JSX.Element {
    const { openModal } = useModal();

    return (
        <section className={s.root}>
            <div className={s.content}>
                <div>
                    <p className={s.title1}>Вривайся в</p>
                    <p className={s.title2}>англомовний кемп</p>
                    <p className={s.title3}>вже цiєї осенi</p>
                </div>

                <button onClick={openModal}>Забронювати місце</button>
                <p className={s.price}>за 5000 грн</p>
            </div>
        </section>
    );
}
